<template>
    <p v-if="isError" class="text-sm text-red-600 mt-2">
      <template v-if="errorMessage && typeof (errorMessage) === 'string'">
        {{ errorMessage }}
      </template>
      <template v-else-if="errorMessage && typeof (errorMessage) === 'object' && isError">
        {{ translate(errorMessage) }}
      </template>
      <template v-else-if="errorMessage">
        {{ 'Este campo es requerido' }}
      </template>
    </p>
</template>
<script setup lang="ts">
import { translate } from '@/modules/Core/usings/generales'
defineProps<{
   isError: boolean
   errorMessage: string | object | undefined | null
}>()
</script>